import React from 'react';
import SvgUrlImage from '#web-components/components/SvgUrlImage';

export default function LoaderImage() {
  return (
    <SvgUrlImage url={`${process.env.PUBLIC_URL}/logos/loader-logo.svg`} />
  );
}
